import React from "react";
import DispatchTrailer from "./DispatchTrailer";

export type PreDispatchTrailerDetailsSyncProps = Omit<
  React.ComponentProps<typeof DispatchTrailer>,
  "ref"
> & {
  onPreDispatchTrailerDetailsSync?: (trailerDetails: unknown[]) => void;
};

/**
 * Keeps parent pre-dispatch state aligned with DispatchTrailer trailerDetails.
 * DispatchTrailer now emits trailerDetails changes directly via callback.
 */
export const PreDispatchTrailerDetailsSync = ({
  onPreDispatchTrailerDetailsSync,
  ...trailerProps
}: PreDispatchTrailerDetailsSyncProps) => (
  <DispatchTrailer
    {...trailerProps}
    onTrailerDetailsChange={onPreDispatchTrailerDetailsSync}
  />
);
